import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import PasswordStrength, { evaluatePassword } from "@/components/PasswordStrength";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!evaluatePassword(password).rulesPassed) { toast.error("Password does not meet strength requirements"); return; }
    setBusy(true);
    try { await register(email, password, name); toast.success("Account created."); nav("/library"); }
    catch (err) { toast.error(err.response?.data?.detail || "Registration failed"); }
    setBusy(false);
  };
  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="register-page">
      <div className="eyebrow mb-3">Join Aperture</div>
      <h1 className="aperture-h1 text-4xl mb-10">Create your account.</h1>
      <form onSubmit={submit} className="space-y-4 bg-white p-8 shadow-xl rounded-sm">
        <div>
          <label className="eyebrow block mb-2">Name</label>
          <input value={name} onChange={(e)=>setName(e.target.value)} data-testid="register-name"
            className="w-full px-4 py-3 border rounded-sm focus:outline-none focus:border-gold text-sm" style={{ borderColor: "rgba(10,37,64,0.15)" }} />
        </div>
        <div>
          <label className="eyebrow block mb-2">Email</label>
          <input type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} data-testid="register-email"
            className="w-full px-4 py-3 border rounded-sm focus:outline-none focus:border-gold text-sm" style={{ borderColor: "rgba(10,37,64,0.15)" }} />
        </div>
        <div>
          <label className="eyebrow block mb-2">Password</label>
          <input type="password" required minLength={12} value={password} onChange={(e)=>setPassword(e.target.value)} data-testid="register-password"
            className="w-full px-4 py-3 border rounded-sm focus:outline-none focus:border-gold text-sm" style={{ borderColor: "rgba(10,37,64,0.15)" }} />
          <PasswordStrength password={password} />
        </div>
        <button disabled={busy} data-testid="register-submit" className="btn-primary w-full py-3 text-xs uppercase tracking-widest rounded-sm">{busy ? "Creating…" : "Create Account"}</button>
      </form>
      <div className="mt-6 text-sm text-navy/70 text-center">
        Already a member? <Link to="/login" data-testid="register-login-link" className="text-gold hover:underline">Sign in</Link>
      </div>
    </div>
  );
}
